import { Outlet} from "react-router-dom";
import MenuBar from "../Components/UI/MenuBar";

function RootLayout (props) {
    return (
        <div>
            <MenuBar isMobile={props.isMobile} />
            <Outlet />
        </div>
    );
}

export default RootLayout;